import { AppActions } from '../constants/App';
import { ScrollKeys, ScrollThresholds } from '../constants/Scroll';
import { Map } from '../lib/ImmutableUtils';
import { createReducer } from '../lib/ReducerUtils';

const INITIAL_STATE = Map({
  [ScrollKeys.SCROLLED_OFFSET]: 0,
  [ScrollKeys.IS_SCROLLED]: false,
  [ScrollKeys.IS_NOWPLAYING_TOP_IN_VIEW]: true,
});
export type ScrollState = typeof INITIAL_STATE;

// SCROLL REDUCER
export default createReducer(INITIAL_STATE, {
  [AppActions.SET_SCROLL_POS]: setScrollPos,
});

// CASE FUNCTIONS

function setScrollPos(state: ScrollState, { payload: { offset } }: $TSFixMe): ScrollState {
  return state.merge({
    [ScrollKeys.SCROLLED_OFFSET]: offset,
    [ScrollKeys.IS_SCROLLED]: offset > ScrollThresholds.SCROLL_FROM_TOP_BUFFER,
    [ScrollKeys.IS_NOWPLAYING_TOP_IN_VIEW]: offset < ScrollThresholds.NOWPLAYING_TOP_HEIGHT,
  });
}
